/**
 * 0埋めされている時間文字列(ex: 00:00)を0埋めされていない時間文字列(ex: 0:00)に変換する。
 * @param time string
 * @returns string
 */
export function formatTime(time: string): string {
  if (!/^[0-9]{2}:[0-9]{2}$/.test(time)) return time;
  const [l, r] = time.split(':');
  return `${Number(l)}:${r}`;
}
